import { useApi } from '@/utils/request'

export const useDashboardApi = () => {
  const [api] = useApi()

  const getDashboardInfo = (data) => {
    return api({
      url: '/dashboard/web/info',
      method: "post",
      data,
    })
  }

  const getDashboardOverview = (data) => {
    return api({
      url: '/dashboard/overview',
      method: "post",
      data,
    })
  }

  const getDashboardCalendar = (data) => {
    return api({
      url: '/dashboard/calendar',
      method: "post",
      data,
    })
  }

  return {
    getDashboardInfo,
    getDashboardOverview,
    getDashboardCalendar
  }
  
}
